import React from 'react';
import { Sparkles } from 'lucide-react';

// "Confirmed 2 of 3 — one more and this vendor posts itself"
export const ConfirmationProgressChip = ({ item, compact = false }) => {
  const p = item?.confirmation_progress;
  if (!p || !p.needed) return null;
  const count = Math.min(p.count || 0, p.needed);
  const left = p.needed - count;
  const tail = left <= 0
    ? 'this vendor now posts itself on refresh'
    : `${left === 1 ? 'one more' : `${left} more`} and this vendor posts itself`;
  const full = `Confirmed ${count} of ${p.needed} — ${tail}`;
  return (
    <div
      data-testid={`confirm-progress-${item.id}`}
      className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded-full border border-emerald-200 bg-emerald-50 text-emerald-800 ${compact ? 'px-2 py-0.5 text-[10px]' : 'px-2.5 py-1 text-xs'}`}
      title={full}
    >
      <Sparkles className={compact ? 'w-3 h-3' : 'w-3.5 h-3.5'} />
      <span className="flex items-center gap-1" aria-hidden>
        {Array.from({ length: p.needed }).map((_, i) => (
          <span key={i} className={`h-1.5 w-1.5 rounded-full ${i < count ? 'bg-emerald-500' : 'bg-emerald-200'}`} />
        ))}
      </span>
      <span>{compact ? `${count} of ${p.needed} confirmed` : full}</span>
    </div>
  );
};

export default ConfirmationProgressChip;
